import PropTypes from 'prop-types';
import { useRef } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, useGSAP);

function AnimationMouvement({ id, containerClassName }) {
    const containerClasses = (containerClassName) ? `animation--mouvement ${containerClassName} nostroke-scale` : 'animation--mouvement nostroke-scale';

    // On définit la référence pour le svg
    const svgRef = useRef(null);

    // On initialise le hook de GSAP pour React afin de gérer l'ajout et la suppression des
    // écouteurs de manière automatique
    useGSAP(() => {
        // On définit notre timeline
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: svgRef.current,
                start: () => `top center-=${(svgRef.current.getBoundingClientRect().height * 18.18) / 100}`, // 200px en desktop
                end: () => `bottom center+=${(svgRef.current.getBoundingClientRect().height * 36.36) / 100}`, // 400px en desktop
                scrub: true
            }
        });

        // On définit le label de la timeline à partir duquel nos animations vont se
        // déclencher
        tl.addLabel("start");

        // On lui ajoute les deux événements from()
        tl.from("#Groupe_mou", {
            y: -350,
            duration: 3,
            ease: "power1.out"
        }, "start");
        tl.from("#Groupe_ment", {
            y: 350,
            duration: 3,
            ease: "power1.out"
        }, "start");
    }, { scope: svgRef });

    return (
        <svg role="img" ref={svgRef} id={id} className={containerClasses} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440.5 839">
            <title>mouvement</title>
            <g id="Groupe_mou">
                <g id="Mou" className="st2">
                <text className="st3" transform="translate(87 458)"><tspan x="0" y="0">mou</tspan></text>
                </g>
                <g id="Groupe_6759">
                <line id="Ligne_3974" className="st0" x1="255.5" y1="635" x2="255.5" y2="786"/>
                <path id="Polygone_3" d="M255,796.5l-9-13h18l-9,13Z"/>
                </g>
            </g>
            <g id="Groupe_ve">
                <g id="ve" className="st2">
                <text className="st1" transform="translate(631 458)"><tspan x="0" y="0">ve</tspan></text>
                </g>
                <line id="Ligne_3885" className="st0" x1="509" y1=".5" x2="509" y2="838.5"/>
                <line id="Ligne_3973" className="st0" x1="932" x2="932" y2="838"/>
                <line id="Ligne_3976" className="st0" x1=".5" y1="558.5" x2="1440.5" y2="558.5"/>
                <line id="Ligne_3978" className="st0" x1="674.5" y1="279" x2="769.5" y2="279"/>
                <line id="Ligne_3977" className="st0" x1="674.5" y1="698.5" x2="769.5" y2="698.5"/>
            </g>
            <g id="Groupe_ment">
                <g id="ment" className="st2">
                <text className="st3" transform="translate(977.7 458)"><tspan x="0" y="0">ment</tspan></text>
                </g>
                <g id="Groupe_6758">
                <line id="Ligne_3975" className="st0" x1="1183.5" y1="200.5" x2="1183.5" y2="49.5"/>
                <path id="Polygone_4" d="M1184,39l9,13h-18l9-13Z"/>
                </g>
            </g>
        </svg>
    )
}

AnimationMouvement.propTypes = {
    id: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
}

export default AnimationMouvement;
